export default __webpack_public_path__ + "static/media/power_spectrum_eeg.9d47cf0f.webp";